import ScrollReveal from '@/components/base/ScrollReveal'

export default function ReviewSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50" aria-labelledby="review-title">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">

          <ScrollReveal direction="left" duration={700} className="w-full lg:w-[40%]">
            <div className="relative rounded-[32px] overflow-hidden bg-accent-100 group" style={{ height: '460px' }}>
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20female%20character%20full%20body%20illustration%2C%20elegant%20pose%2C%20soft%20pastel%20color%20palette%2C%20clean%20digital%20art%2C%20minimal%20background%20with%20soft%20gradient%2C%20modern%20webtoon%20aesthetic%2C%20delicate%20linework%2C%20warm%20coral%20and%20cream%20tones%2C%20floating%20petals%2C%20dreamy%20atmosphere&width=800&height=920&seq=review-character-01&orientation=portrait"
                alt="韩漫角色立绘"
                className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-700 ease-out"
                loading="lazy"
              />
            </div>
          </ScrollReveal>

          <div className="w-full lg:w-[60%] space-y-6">
            <ScrollReveal direction="up" delay={100} duration={500}>
              <span className="inline-block text-xs font-medium text-foreground-500">
                （ 读者好评 ）
              </span>
            </ScrollReveal>

            <ScrollReveal direction="up" delay={200} duration={600}>
              <h2 id="review-title" className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-[1.2]">
                为什么百万读者
                <br />
                <span className="text-foreground-300">每天蹲守更新</span>
              </h2>
            </ScrollReveal>

            <ScrollReveal direction="up" delay={350} duration={550}>
              <blockquote className="text-base md:text-lg text-foreground-600 leading-relaxed italic border-l-4 border-primary-300 pl-5 max-w-xl">
                &ldquo;这里的每一部韩漫都像在追韩剧，分镜电影感极强，画风精致到可以截图当壁纸。更新速度超快，翻译质量也很高，已经成为我每天必刷的精神食粮！&rdquo;
              </blockquote>
            </ScrollReveal>

            <ScrollReveal direction="up" delay={450} duration={450}>
              <div className="flex items-center gap-2 pt-2">
                <span className="text-sm font-semibold text-foreground-900">— 来自资深漫评人</span>
                <span className="text-sm text-primary-500 font-medium">@漫画姬</span>
              </div>
            </ScrollReveal>

            <ScrollReveal direction="up" delay={550} duration={400}>
              <div className="flex items-center gap-3 pt-6">
                <button
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-300 text-foreground-500 hover:border-foreground-500 hover:text-foreground-700 hover:-translate-y-0.5 active:translate-y-0 transition-all duration-200 cursor-pointer"
                  aria-label="上一条评论"
                >
                  <i className="ri-arrow-left-line text-sm"></i>
                </button>
                <button
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 hover:bg-foreground-800 hover:-translate-y-0.5 active:translate-y-0 transition-all duration-200 cursor-pointer"
                  aria-label="下一条评论"
                >
                  <i className="ri-arrow-right-line text-sm"></i>
                </button>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </section>
  )
}